module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bannerWord",
    attrs: {
      "src": require("../assets/bannerWord.png")
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "bannerMore",
    attrs: {
      "src": require("../assets/bannerMore.png")
    },
    on: {
      "click": _vm.More
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottleNeck"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "center-img",
    attrs: {
      "src": require("../assets/title3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, _vm._l((_vm.bottleNeck), function(bottleneck, index) {
    return _c('el-col', {
      staticStyle: {
        "width": "19.9rem"
      },
      attrs: {
        "span": 4
      },
      nativeOn: {
        "mouseover": function($event) {
          return _vm.mouseon(index)
        },
        "mouseout": function($event) {
          return _vm.mouseout(index)
        }
      }
    }, [_c('div', {
      class: {
        moveChange: _vm.activeName2 == index
      },
      staticStyle: {
        "height": "auto",
        "background-color": "#fff",
        "-webkit-transition": "all .6s"
      },
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('img', {
      staticClass: "image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": bottleneck.picc
      }
    }), _vm._v(" "), _c('div', {
      class: {
        colorChange: _vm.activeName2 == index
      },
      staticStyle: {
        "-webkit-transition": "all .6s"
      }
    }, [_c('div', {
      staticClass: "cardBox"
    }, [_c('h4', {
      class: {
        Number: _vm.activeName2 != index,
        NumberChange: _vm.activeName2 == index
      }
    }, [_vm._v(_vm._s(bottleneck.No))]), _vm._v(" "), _c('h4', {
      class: {
        titles: _vm.activeName2 != index,
        titleChange: _vm.activeName2 == index
      }
    }, [_vm._v(_vm._s(bottleneck.title))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix descriptionBottom",
      staticStyle: {
        "clear": "both",
        "padding": "0 1rem",
        "box-sizing": "border-box",
        "text-align": "left"
      }
    }, [_c('h4', {
      class: {
        description: _vm.activeName2 != index,
        descriptionChange: _vm.activeName2 == index
      }
    }, [_vm._v(_vm._s(bottleneck.content))])])])])])
  }), 1)], 1), _vm._v(" "), _c('img', {
    staticClass: "center-img",
    attrs: {
      "src": require("../assets/title2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0",
      "padding": "0"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, _vm._l((_vm.playerNeck1), function(bottleneck, index) {
    return _c('el-col', {
      staticStyle: {
        "width": "19.9rem",
        "height": "28.5rem"
      },
      attrs: {
        "span": 4
      },
      nativeOn: {
        "mouseover": function($event) {
          return _vm.mouseonn(index)
        },
        "mouseout": function($event) {
          return _vm.mouseoutt(index)
        }
      }
    }, [_c('div', {
      class: {
        moveChange: _vm.activeName2 == index - 4
      },
      staticStyle: {
        "height": "auto",
        "background-color": "#fff",
        "-webkit-transition": "all .6s"
      },
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('img', {
      staticClass: "image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": bottleneck.picc
      }
    }), _vm._v(" "), _c('div', {
      class: {
        colorChange: _vm.activeName2 == index - 4
      },
      staticStyle: {
        "height": "15.2rem",
        "margin-top": "-0.5rem"
      }
    }, [_c('div', {
      staticClass: "cardBox"
    }, [_c('h4', {
      class: {
        Number: _vm.activeName2 != index - 4,
        NumberChange: _vm.activeName2 == index - 4
      }
    }, [_vm._v(_vm._s(bottleneck.No))]), _vm._v(" "), _c('h4', {
      class: {
        titles: _vm.activeName2 != index - 4,
        titleChange: _vm.activeName2 == index - 4
      }
    }, [_vm._v(_vm._s(bottleneck.title))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix descriptionBottom",
      staticStyle: {
        "clear": "both",
        "padding": "0 1rem",
        "box-sizing": "border-box",
        "text-align": "left"
      }
    }, [_c('h4', {
      class: {
        description: _vm.activeName2 != index - 4,
        descriptionChange: _vm.activeName2 == index - 4
      }
    }, [_vm._v(_vm._s(bottleneck.content))])])])])])
  }), 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0",
      "margin": "0"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, _vm._l((_vm.playerNeck2), function(bottleneck, index) {
    return _c('el-col', {
      staticStyle: {
        "width": "19.9rem",
        "height": "28.5rem"
      },
      attrs: {
        "span": 4
      },
      nativeOn: {
        "mouseover": function($event) {
          return _vm.mouseOn(index)
        },
        "mouseout": function($event) {
          return _vm.mouseOut(index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (bottleneck.opacity),
        expression: "bottleneck.opacity"
      }],
      class: {
        moveChange: _vm.activeName2 == index + 4
      },
      staticStyle: {
        "height": "auto",
        "background-color": "#fff",
        "-webkit-transition": "all .6s"
      },
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('img', {
      staticClass: "image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": bottleneck.picc
      }
    }), _vm._v(" "), _c('div', {
      class: {
        colorChange: _vm.activeName2 == index + 4
      },
      staticStyle: {
        "height": "15.2rem",
        "margin-top": "-0.5rem",
        "-webkit-transition": "all .6s"
      }
    }, [_c('div', {
      staticClass: "cardBox"
    }, [_c('h4', {
      class: {
        Number: _vm.activeName2 != index + 4,
        NumberChange: _vm.activeName2 == index + 4
      }
    }, [_vm._v(_vm._s(bottleneck.No))]), _vm._v(" "), _c('h4', {
      class: {
        titles: _vm.activeName2 != index + 4,
        titleChange: _vm.activeName2 == index + 4
      }
    }, [_vm._v(_vm._s(bottleneck.title))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix descriptionBottom",
      staticStyle: {
        "clear": "both",
        "padding": "0 1rem",
        "box-sizing": "border-box",
        "text-align": "left"
      }
    }, [_c('h4', {
      class: {
        description: _vm.activeName2 != index + 4,
        descriptionChange: _vm.activeName2 == index + 4
      }
    }, [_vm._v(_vm._s(bottleneck.content))])])])])])
  }), 1)], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "service"
  }, [_vm._m(2), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0",
      "padding-bottom": "5.9rem"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, _vm._l((_vm.service), function(bottleneck, index) {
    return _c('el-col', {
      class: {
        moveChange: _vm.activeName2 == index + 8
      },
      staticStyle: {
        "width": "12.8rem",
        "background-color": "#fff",
        "padding": "0",
        "margin-left": "10px",
        "margin-right": "10px",
        "-webkit-transition": "all .6s"
      },
      attrs: {
        "span": 3
      },
      nativeOn: {
        "mouseover": function($event) {
          return _vm.mouseOnn(index)
        },
        "mouseout": function($event) {
          return _vm.mouseOutt(index)
        }
      }
    }, [_c('div', {
      class: {
        colorChange: _vm.activeName2 == index + 8
      },
      staticStyle: {
        "width": "12.8rem",
        "-webkit-transition": "all .6s"
      },
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('img', {
      staticClass: "serviceImage",
      attrs: {
        "src": _vm.activePic4[index].show ? bottleneck.pic : bottleneck.picc
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "auto"
      }
    }, [_c('h5', {
      class: {
        Titlee: _vm.activeName2 != index + 8,
        titleChange2: _vm.activeName2 == index + 8
      }
    }, [_vm._v(_vm._s(bottleneck.title))]), _vm._v(" "), _c('img', {
      staticClass: "buttonPic",
      attrs: {
        "src": _vm.activePic4[index].show ? _vm.button1 : _vm.button2
      },
      on: {
        "click": _vm.LearnMore
      }
    })])])])
  }), 1)], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "MerchantAlliance"
  }, [_vm._m(4), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0",
      "height": "80px",
      "margin": "0",
      "padding": "0"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "222px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/27.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "307px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/p24.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "222px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/26.png")
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px",
      "margin-top": "8px",
      "padding-bottom": "77px"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "222px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/25.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "307px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tencent.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "222px",
      "height": "80px",
      "box-sizing": "content-box",
      "padding-left": "0"
    },
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/28.png")
    }
  })])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-title"
  }, [_c('h4', {
    staticClass: "titleC"
  }, [_vm._v("行业痛点")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Bottleneck Of The Industry")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "methods"
  }, [_c('div', {
    staticClass: "center-title"
  }, [_c('h4', {
    staticClass: "titleC",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("如何突破")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish",
    staticStyle: {
      "color": "#cccccc"
    }
  }, [_vm._v("How to Break Through")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })]), _vm._v(" "), _c('img', {
    staticClass: "p12 center-img",
    attrs: {
      "src": require("../assets/p12.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-title"
  }, [_c('h4', [_vm._v("我们的产品与服务")]), _vm._v(" "), _c('p', [_vm._v("Our Products And Services")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cooperationExa"
  }, [_c('div', {
    staticClass: "center-title"
  }, [_c('h4', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#cccccc"
    }
  }, [_vm._v("Successful Examples Of Cooperation")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "leftPic",
    attrs: {
      "src": require("../assets/left.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bannerPicture swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/p23.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey"
  }, [_c('p', [_vm._v("1、客人无需在考虑没带会员卡能否去游乐园游乐厅玩，甚至不需要带钱包，只要带上手机即可客人无需在考虑没带会员卡能否去游乐园游乐厅玩，甚至不需要带钱包，只要带上手机即可客人无需在考虑没带会员卡能否去游乐园游乐厅玩，甚至不需要带钱包，只要带上手机即可客人无需在考虑没带会员卡能否去游乐园游乐厅玩，甚至不需要带钱包")]), _c('img', {
    attrs: {
      "src": require("../assets/button3.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "rightPic",
    attrs: {
      "src": require("../assets/right.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-title"
  }, [_c('h4', [_vm._v("商家联盟")]), _vm._v(" "), _c('p', [_vm._v("Merchant Alliance")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e080b89","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 280
// module chunks = 1